import React from "react";
import { useState } from "react";
import { FileWithShare } from "../../../../lib/supabase/supabaseTypes";
import { getFileType } from "@/lib/utils/file-utils";
import { GalleryImageItem } from "./gallery-image-item.component";
import { FocusedItem } from "./focused-item.component";
import { useJobStore } from "../../store/Job";

export type FileWithImage = FileWithShare & {
	image?: string;
};

export const ImagesGallery = ({
	id,
	connectedOrganizationId,
}: {
	id: string | number;
	connectedOrganizationId?: string;
}) => {
	const { labImages, medImages, shareFile, unshareFile } = useJobStore();

	const [focusedFile, setFocusedFile] = useState<FileWithImage | null>(null);

	const shareButtonText = (file: FileWithImage) => {
		if (file.shared_ids && file.shared_ids[0]) {
			return file.shared_until ? "Erneut teilen" : "Entteilen";
		}
		return "Teilen";
	};

	const handleShareButtonClick = (file: FileWithImage) => {
		if (!file.id) return;
		if (!file.job_id) return;

		if (file.shared_ids && file.shared_ids[0]) {
			if (file.shared_until && new Date(file.shared_until) < new Date()) {
				shareFile(file.id, file.job_id);
			} else {
				unshareFile(file.id, file.job_id);
			}
		} else {
			shareFile(file.id, file.job_id);
		}
	};

	if (!id || (labImages.length == 0 && medImages.length == 0)) {
		return <div className="text-center my-4">Keine Bilder vorhanden</div>;
	}

	return (
		<div className="mt-2">
			<div className=" overflow-y-auto">
				<>
					{(labImages.length > 0 || medImages.length > 0) && (
						<>
							{labImages.length > 0 && (
								<>
									<div className="font-bold">Eigene:</div>
									<div className="grid grid-cols-4 gap-2 p-2">
										{labImages.map(
											(image) =>
												image.meta_data &&
												image.file_name &&
												getFileType(
													image.meta_data as Record<string, any>,
													image.file_name
												) == "img" && (
													<GalleryImageItem
														key={image.id}
														labImage={true}
														file={image}
														onClick={() =>
															setFocusedFile(
																image
															)
														}
													/>
												)
										)}
									</div>
								</>
							)}
							{medImages.length > 0 && (
								<>
									<div className="font-bold">
										Von Auftraggeber:
									</div>
									<div className="grid grid-cols-4 gap-2 p-2">
										{medImages.map(
											(image) =>
												image.meta_data &&
												image.file_name &&
												getFileType(
													image.meta_data as Record<string, any>,
													image.file_name
												) == "img" && (
													<GalleryImageItem
														key={image.id}
														labImage={false}
														file={image}
														onClick={() =>
															setFocusedFile(
																image
															)
														}
													/>
												)
										)}
									</div>
								</>
							)}
						</>
					)}
				</>
				<FocusedItem
					file={focusedFile}
					onClose={() => setFocusedFile(null)}
					handleShareButtonClick={handleShareButtonClick}
					connectedOrganizationId={connectedOrganizationId}
					shareButtonText={shareButtonText}
				/>
			</div>
		</div>
	);
};
